export default __webpack_public_path__ + "static/media/91.700b6391.png";